import { useState } from "react";
import { compose } from "redux";
import { claimsConnector } from "../services/claims/claimsConnector";
import { withClaims } from "../HoC/claims/withClaims";

export function getTokenDateDelta() {
  let jwt = localStorage.getItem("admin.usr");
  if (jwt) {
    const jwtExp = JSON.parse(jwt)["expires_in"];
    const dateNow = new Date();
    const dateExp = new Date(jwtExp);

    if (dateNow > dateExp) return -1;

    return (dateExp.getTime() - dateNow.getTime()) / 1000;
  }
  return -1;
}

const _userClaimsAuthenticated =
  (Cmp) =>
  ({ claimAuth, excludeClaimAuth, claims, ...rest }) => {
    const [hasAMLClaim] = useState(initState);

    function initState() {
      let result = true;

      if (excludeClaimAuth)
        result = !excludeClaimAuth.some((ca) =>
          Object.keys(claims.data).includes(ca),
        );

      if (claimAuth)
        result = claimAuth.some((ca) => Object.keys(claims.data).includes(ca));

      return result;
    }

    if (hasAMLClaim) return <Cmp {...rest} />;

    return <div>Unathorized to view this page</div>;
  };
export const UserClaimsAuthenticated = compose(
  claimsConnector,
  withClaims,
  _userClaimsAuthenticated,
);
